import Image from "next/image";
import React from "react";

export default function InitiativeCardIcons({ icon }) {
  return (
    <Image
      src={process.env.NEXT_PUBLIC_SPACES_URL + icon}
      alt="membership"
      height={30}
      width={30}
      className="w-fit  mx-auto  duration-300 object-cover group-hover:brightness-0 group-hover:invert-[1]"
    />
  );
}
